// extracted by mini-css-extract-plugin
export var accordion = "_fr-0";
export var chevron = "_fr-3";
export var closed = "_fr-2";
export var content = "_fr-4";
export var open = "_fr-1";
export var rotate = "_fr-5";